"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNameBuilders_1 = require("../../../lib/classNameBuilders");
const HeaderCell_1 = require("./HeaderCell");
const FilesTableContext_1 = require("../FilesTableContext");
const HeaderRow = () => {
    const { columns } = (0, react_1.useContext)(FilesTableContext_1.FilesTableContext);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classNameBuilders_1.bem)('table__row') }, { children: columns.map((column, index) => ((0, jsx_runtime_1.jsx)(HeaderCell_1.HeaderCell, { column: column }, index))) }), void 0));
};
exports.HeaderRow = HeaderRow;
//# sourceMappingURL=HeaderRow.js.map